
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Winners } from 'components/winners'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`760 Romands ont participé à notre quiz sur les élections fédérales. Le gagnant a obtenu 23 points sur un total de 29 (soit 79% de réponses correctes). Il empoche un abonnement numérique d'une année à 24heures, Tribune de Genève ou Le Matin dimanche. La moyenne des points obtenue par l'ensemble des participants s'élève à 16,45. Retrouvez ci-dessous toutes les réponses correctes.`}</p>
    <Winners mdxType="Winners" />
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;